export const isLoggedIn = state => state.auth.isLoggedIn
export const role = state => state.auth.role
export const token = state => state.auth.token



// WEBPACK FOOTER //
// ./src/vuex/auth/getters.js